import { useCallback } from 'react';
import { useSweepApi } from '../sweep';
import { ObjectData } from '../../components/parser/ParserTypes';

export const useDocumentationApiFacade = () => {
  const sweepApi = useSweepApi();

  return {
    post_createObject: useCallback(
      async ({ payload }: { payload: { name: string; label: string; visible: boolean } }) => {
        const response = await sweepApi.post<ObjectData>(`/documentation`, payload);
        return response.data;
      },
      [sweepApi],
    ),
    patch_toggleObjectVisibility: useCallback(
      async (objectName: string, visible: boolean) => {
        return await sweepApi.patch(`/documentation/${objectName}`, {
          visible,
        });
      },
      [sweepApi],
    ),
  };
};
